import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { TQuickLinksProps } from '../components/quickLinks/types/quickLinks.types';
import { TSitecoreContext } from '../types/sitecore.types';

export const checkMobileQuickLinksEmpty = (sitecoreContext: TSitecoreContext): boolean => {
    const quickLinksData: unknown = (sitecoreContext?.route?.placeholders?.['jss-main'] as ComponentRendering[])?.find(_ => _?.componentName === 'QuickLinks') || {};
    const isMobileQuickLinksEmpty = (quickLinksData as TQuickLinksProps)?.fields?.items?.find( _ => _.fields?.isMobile?.value );
    return !isMobileQuickLinksEmpty
}